import { render, staticRenderFns } from "./PageList.vue?vue&type=template&id=00641298"
import script from "./PageList.vue?vue&type=script&lang=js"
export * from "./PageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports